import "./PasswordPage.scss";
import React, {useEffect, useState} from "react";
import MembersApi from "../api/MembersApi";
import LoginPageStep from "./register/LoginPageStep";
import {NavLink, useLocation} from "react-router-dom";

export default function PasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const location = useLocation();
  const state = location.state || {};

  useEffect(() => {
    if (!state.email) return;
    setEmail(state.email);
  }, [state.email]);

  async function submit() {
    setError('');
    try {
      setLoading(true);
      await MembersApi.generatePassword(email);
      setSuccess(true);
    } catch (err) {
      setLoading(false);
      setError('The email address is not associated with an account. Please try another email address.');
    }
  }

  function onBack() {
    window.history.back();
  }

  return (
    <div className={"reg-page"}>
      <div className={'left'}>
        <div className="cvr"/>
      </div>
      <div className={'right'}>
        {!success && <LoginPageStep email={email} step={'forgot-password'} onEmailChange={setEmail} onBack={onBack} loading={loading} error={error} onNext={submit} password={''} onPasswordChange={() => {}}/>}
        {success && <div className={"success-next step full"}>
          <img src={"https://www.musthavemenus.com/imageservice/images/img/13/icons/check.svg"} alt={"check"} />
          <h2>Password Sent</h2>
          <h5>
            Email has been sent to {email} containing a new password.
          </h5>
          <footer>
            <NavLink className={"ant-btn ant-btn-default ant-btn-lg primary pass-res"} to={"/account/login"} state={{email, step: 'pass'}}>Sign in to reset</NavLink>
          </footer>
        </div>}
      </div>
    </div>
  );
}
